import i18n from "../i18n";

export const Currencies = [
  {
    id: "ARS",
    locale: "es-ar",
    label: "ARS",
    description: i18n.t("currencies:ARS")
  },
  {
    id: "CLP",
    locale: "es-cl",
    label: "CLP",
    description: i18n.t("currencies:CLP")
  },
  {
    id: "USD",
    locale: "en-us",
    label: "USD",
    description: i18n.t("currencies:USD")
  },
  {
    id: "UYU",
    locale: "es-uy",
    label: "UYU",
    description: i18n.t("currencies:UYU")
  },
  {
    id: "MXN",
    locale: "es-mx",
    label: "MXN",
    description: i18n.t("currencies:MXN")
  },
  {
    id: "EUR",
    locale: "es-es",
    label: "EUR",
    description: i18n.t("currencies:EUR")
  },
  {
    id: "PEN",
    locale: "es-pe",
    label: "PEN",
    description: i18n.t("currencies:PEN")
  },
  {
    id: "VED",
    locale: "es-ve",
    label: "VED",
    description: i18n.t("currencies:VED")
  },
  {
    id: "COP",
    locale: "es-co",
    label: "COP",
    description: i18n.t("currencies:COP")
  },
  {
    id: "BRS",
    locale: "pr-br",
    label: "BRS",
    description: i18n.t("currencies:BRS")
  },
  {
    id: "QTZ",
    locale: "es-gt",
    label: "QTZ",
    description: i18n.t("currencies:QTZ")
  },
  {
    id: "SVC",
    locale: "es-sv",
    label: "SVC",
    description: i18n.t("currencies:SVC")
  },
  {
    id: "DOP",
    locale: "es-do",
    label: "DOP",
    description: i18n.t("currencies:DOP")
  },
  {
    id: "BOB",
    locale: "es-bo",
    label: "BOB",
    description: i18n.t("currencies:BOB")
  }
].sort((a, b) => a.description.localeCompare(b.description));
